<template>
  <div id="app">
    <nav>
      <div class="p-nav">
        <div class="left">
          <router-link to="/about">{{ $t('content.menu.item[0]') }}</router-link>
          <router-link to="/product">{{ $t('content.menu.item[1]') }}</router-link>
          <router-link to="/design">{{ $t('content.menu.item[2]') }}</router-link>
          <router-link to="/video">{{ $t('content.menu.item[3]') }}</router-link>
          <router-link to="/contact">{{ $t('content.menu.item[4]') }}</router-link>
        </div>
        <div class="right">
          <div class="r-top">
            <a href="https://www.nestspace.uk/login" target="_blank">
              <img src="./assets/icons/icon-login.png">
            </a>
            <!-- <a href="javascript:;" :style="{ textDecoration: this.language == 'zh' ? 'revert' : 'none' }"
              @click="btn_language('zh')">中文</a>
            <div class="t-line"></div>
            <a href="javascript:;" :style="{ textDecoration: this.language == 'en' ? 'revert' : 'none' }"
              @click="btn_language('en')">ENG</a> -->
          </div>
          <div class="right-menu" @mouseenter="handleRightMenuMouseEnter()" @mouseleave="handleRightMenuMouseLeave()">
            <div class="right-menu-top">
              <div>China</div>
              <img src="./assets/icons/icon-down.png">
            </div>
            <div class="right-menu-bottom" v-if="isShowRightMenu">
              <a href="https://www.nestspace.cn" target="_blank">China</a>
              <a href="https://www.nestspace.com" target="_blank">International</a>
              <a href="https://www.nestspace.uk" target="_blank">United Kingdom </a>
              <a href="https://www.nestspace.com" target="_blank">Belgium</a>
            </div>
          </div>
        </div>
      </div>
      <div class="m-nav">
        <div class="left">
          <router-link to="/about">{{ $t('content.menu.item[0]') }}</router-link>
          <router-link to="/product">{{ $t('content.menu.item[1]') }}</router-link>
          <router-link to="/design">{{ $t('content.menu.item[2]') }}</router-link>
          <router-link to="/video">{{ $t('content.menu.item[3]') }}</router-link>
          <router-link to="/contact">{{ $t('content.menu.item[4]') }}</router-link>
        </div>
        <div class="right">
          <div class="r-top">
            <a href="https://www.nestspace.uk/login" target="_blank">
              <img src="./assets/icons/icon-login.png">
            </a>
            <!-- <a href="javascript:;" :style="{ textDecoration: this.language == 'zh' ? 'revert' : 'none' }"
              @click="btn_language('zh')">中文</a>
            <div class="t-line"></div>
            <a href="javascript:;" :style="{ textDecoration: this.language == 'en' ? 'revert' : 'none' }"
              @click="btn_language('en')">ENG</a> -->
          </div>
          <div class="right-menu" @mouseenter="handleRightMenuMouseEnter()" @mouseleave="handleRightMenuMouseLeave()">
            <div class="right-menu-top">
              <div>China</div>
              <img src="./assets/icons/icon-down.png">
            </div>
            <div class="right-menu-bottom" v-if="isShowRightMenu">
              <a href="https://www.nestspace.cn" target="_blank">China</a>
              <a href="https://www.nestspace.com" target="_blank">International</a>
              <a href="https://www.nestspace.uk" target="_blank">United Kingdom </a>
              <a href="https://www.nestspace.com" target="_blank">Belgium</a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="p-logo">
      <router-link to="/">
        <!-- <img src="./assets/images/logo-cn-zh.png"> -->
        <img v-if="this.language == 'zh'" src="./assets/icons/logo-zh.png">
        <img v-else src="./assets/icons/logo-en.png">
      </router-link>
    </div>
    <router-view />
    <footer>
      <div class="d-menu">
        <div class="d-panel">
          <router-link to="/about">{{ $t('content.menu.item[0]') }}</router-link>
          <router-link to="/product">{{ $t('content.menu.item[1]') }}</router-link>
          <router-link to="/design">{{ $t('content.menu.item[2]') }}</router-link>
          <router-link to="/video">{{ $t('content.menu.item[3]') }}</router-link>
          <router-link to="/contact">{{ $t('content.menu.item[4]') }}</router-link>
        </div>
      </div>
      <div class="d-line"></div>
      <img class="d-logo" src="./assets/images/logo2.png">
      <div class="d-list">
        <div class="l-panel" @click="btnYouTobe" v-show="this.language == 'en'">
          <img src="./assets/images/footer05.png" style="width: 80%;height: auto;">
          <img src="" style="display: none;">
        </div>
        <div class="l-panel" v-show="this.language == 'en'">
          <img src="./assets/images/footer04.png" @mouseenter="handleMouseEnter(1)" @mouseleave="handleMouseLeave(1)" style="width: 50%;height: auto;">
          <img v-show="listShow[1]" src="./assets/images/f41.png">
        </div>
        <div class="l-panel">
          <img src="./assets/images/footer01.png" @mouseenter="handleMouseEnter(2)" @mouseleave="handleMouseLeave(2)" style="width: 50%;height: auto;">
          <img v-show="listShow[2]" src="./assets/images/footer04.jpg">
        </div>
        <div class="l-panel">
          <img src="./assets/images/footer02.png" @mouseenter="handleMouseEnter(3)" @mouseleave="handleMouseLeave(3)">
          <img v-show="listShow[3]" src="./assets/images/footer05.jpg">
        </div>
        <div class="l-panel">
          <img src="./assets/images/footer03.png" @mouseenter="handleMouseEnter(4)" @mouseleave="handleMouseLeave(4)">
          <img v-show="listShow[4]" src="./assets/images/footer06.jpg">
        </div>
      </div>
      <a href="https://www.trayton.cn/" class="d-herf">
        {{ $t('content.footer[0]') }}
      </a>
      <div class="d-vis">
        {{ $t('content.footer[1]') }} <a href="https://beian.miit.gov.cn/" target="_blank">{{ $t('content.footer[2]')
        }}</a>
      </div>
    </footer>
  </div>
</template>

<style lang="less">
@font-face {
  font-family: "Righteous-Regular";
  src: url('./font-familys/Righteous-Regular.ttf')
}

@font-face {
  font-family: "Gotham-ExtraLight";
  src: url('./font-familys/Gotham-ExtraLight.otf')
}

@font-face {
  font-family: "SourceHanSansSC-Light";
  src: url('./font-familys/SourceHanSansSC-Light.otf')
}

body {
  margin: 0;
  // font-family: Gotham-ExtraLight;
}

[lang="en"] body {
  font-family: Gotham-ExtraLight;
  .top-title{
    font-family: 'GOTHAM';
  }
}

[lang="zh"] body {
  font-family: SourceHanSansSC-Light;
  .top-title{
    font-family: SourceHanSansSC-Light;
  }
}

.gotham {
  font-family: Gotham-ExtraLight;
}

.source {
  font-family: SourceHanSansSC-Light;
}

// .fontFamily2 {
//   font-family: 'GOTHAM';
// }

nav {
  .p-nav {
    position: absolute;
    z-index: 100;
    left: 10%;
    top: 30%;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: start;
    width: 80%;
    height: 180px;
    // background-color: aqua;
    font-size: 18px;

    .left {
      display: flex;
      justify-content: left;
      align-items: center;
      flex-wrap: wrap;
      column-gap: 60px;

      a {
        padding: 0 10px;

        &.router-link-exact-active {
          border-left: 3px solid #ffffff;
        }
      }
    }

    .right {
      width: 200px;
      height: 200px;
      // border: 1px solid red;
          display: flex;
        justify-content: center;
        align-items: start;
        column-gap: 15px;
      .r-top{
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 10px;
        // margin-bottom: 10px;

        .t-line {
          width: 1px;
          height: 20px;
          border-left: 1px solid #ffffff;
        }
      }

       .right-menu{
          font-size: 12px;
          .right-menu-top{
            border: 1px solid #DBDBDB;
            padding: 5px 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 10px;
            cursor: pointer;
            min-width: 120px;
            img{
              width: 10px;
              height: auto;
            }
          }
          .right-menu-bottom{
            background-color: #ffffff;
            // border: 1px solid red;
            padding: 0 10px;
            opacity: 0.5;
            min-width: 120px;
            a{
              display: block;
              margin-top: 10px;
              text-align: left;
              color: #000000;
            }
            a:hover{
              color: #444343;
            }
          }
        }
    }
  }

  .m-nav {
    position: absolute;
    z-index: 100;
    left: 10%;
    top: 25%;
    color: #ffffff;
    width: 80%;
    height: 50px;
    // background-color: aqua;
    font-size: 18px;

    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      row-gap: 20px;

      a {
        padding: 0 10px;

        &.router-link-exact-active {
          border-left: 3px solid #ffffff;
        }
      }
    }

      .right {
      width: 180px;
      height: 200px;
      margin: auto;
      margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: start;
      column-gap: 10px;
      // border: 1px solid red;
      .r-top{
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 10px;
        // margin-bottom: 10px;

        // img{
        //   height: 20px;
        //   width: auto;
        // }

        .t-line {
          width: 1px;
          height: 20px;
          border-left: 1px solid #ffffff;
        }
      }

       .right-menu{
          font-size: 12px;
          .right-menu-top{
            border: 1px solid #DBDBDB;
            padding: 5px 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 10px;
            cursor: pointer;
            img{
              width: 10px;
              height: auto;
            }
          }
          .right-menu-bottom{
            background-color: #ffffff;
            // border: 1px solid red;
            padding: 0 10px;
            opacity: 0.5;
            a{
              display: block;
              margin-top: 10px;
              text-align: left;
              color: #000000;
            }
            a:hover{
              color: #444343;
            }
          }
        }
    }
  }

  a {
    display: block;
    color: #ffffff;
    text-decoration: none;
  }

  a:hover {
    color: #b5b5b5;
  }
}

.f-carousel {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;

  .content {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;

    .panel {
      width: 70%;
      position: relative;
      z-index: 3;

      .title {
        font-size: 48px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 50px;
      }

      .title2 {
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 50px;
      }

      .detail {
        font-size: 19px;
        color: #323232;
        line-height: 28px;
      }
    }
  }

  .t-slide {
    width: 50%;
    height: 100%;

    .panel {
      width: 100%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f5f5f5;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}

.leftOfRight {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;

  .img-back {
    width: 50%;
    height: auto;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .content {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;

    .panel {
      width: 80%;
      position: relative;
      z-index: 3;

      .title {
        font-size: 48px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 50px;
      }

      .title2 {
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 50px;
      }

      .detail {
        font-size: 19px;
        color: #323232;
        line-height: 28px;
      }
    }
  }
}

.p-logo {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 13%;
  width: 100%;
  height: auto;
  text-align: center;
}

.a-btn {
  color: #ffffff;
  text-decoration: none;
  border: 1px solid #ffffff;
  padding: 10px 20px;
}

.a-btn:hover {
  color: #f5f5f5;
  border: 1px solid #f5f5f5;
}

footer {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 500px;
  text-align: center;
  padding-top: 100px;

  .d-menu {
    position: absolute;
    z-index: 5;
    left: 10%;
    top: 0;
    width: 200px;
    height: 100%;
    // background-color: sandybrown;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;

    .d-panel {
      // background-color: darkcyan;
      border-left: 10px solid #000000;
      padding-left: 40px;

      a {
        text-decoration: none;
        width: 100%;
        display: block;
        margin-bottom: 10px;
        color: #000000;
      }

      a:hover {
        color: #000000;
      }
    }
  }

  .d-line {
    width: 80%;
    height: 0;
    border-bottom: 1px solid #000000;
    margin: auto;
    margin-bottom: 100px;
  }

  .d-logo {
    width: 220px;
    height: auto;
    margin-bottom: 30px;
  }

  .d-list {
    max-width: 80%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 40px;
    row-gap: 30px;
    margin-bottom: 20px;
    position: relative;
    z-index: 2;

    .l-panel {
      width: 70px;
      height: 70px;
      border: 1px solid #000000;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: relative;
      z-index: 3;

      img:last-child {
        width: 130px;
        height: auto;
        position: absolute;
        left: 0;
        bottom: 70px;
        z-index: 4;
      }
    }

  }

  .d-herf {
    color: #16418a;
    text-decoration: none;
    margin-bottom: 20px;
    display: block;
  }

  .d-vis {
    font-size: 14px;
    a {
      color: #16418a;
      text-decoration: none;
    }
  }
}

@media (max-width:600px) {
  nav {
    .p-nav {
      display: none;
    }
  }

  .f-carousel {
    height: auto;

    .content {
      width: 100%;
      padding: 50px 0;
    }

    .t-slide {
      width: 100%;

      .panel {
        height: 60vh;
      }
    }

    .f1 {
      height: auto;
    }
  }

  .leftOfRight {
    .content {
      width: 100%;
      padding: 50px 0;
    }

    .img-back {
      width: 100%;
    }
  }

  footer {
    height: 700px;

    .d-menu {
      position: relative;
      height: auto;
      justify-content: left;
      padding-left: 10%;
      margin-bottom: 30px;
    }
  }
}

@media (min-width: 600px) {
  nav {
    .m-nav {
      display: none;
    }
  }
}
</style>
<script>
import { getCountryCode } from './utils/api';
export default {
  data() {
    return {
      scrollTop: 0,
      language: localStorage.getItem("lang") || "zh",
      listShow: [false, false, false, false, false],
      isShowRightMenu:false
    }
  },
  created() {
    document.title = this.language == 'zh' ? 'NEST空间官网' : 'nest space website';
    document.documentElement.setAttribute('lang', this.language);
    this.getIp();
  },
  mounted() {

  },
  methods: {
    getIp(){
      const currentHost = String(window.location.hostname || '').trim().toLowerCase();
      const isCnHost = currentHost === 'nestspace.cn' || currentHost.endsWith('.nestspace.cn');
      const isComHost = currentHost === 'nestspace.com' || currentHost.endsWith('.nestspace.com');

      if (isCnHost) {
        if (this.language !== 'zh') {
          this.btn_language('zh');
        }
        return;
      }

      getCountryCode({}).then(
        response => {
          if (response.code == 200) {
            const countryCode = String(response.result || '').trim().toUpperCase();
            const nextLang = isComHost ? 'en' : (countryCode === 'CN' ? 'zh' : 'en');
            if (this.language !== nextLang) {
              this.btn_language(nextLang);
              return;
            }
            if (countryCode === 'CN') {
              return;
            }
            const targetMap = {
              UK: 'https://www.nestspace.uk'
            };
            const targetUrl = targetMap[countryCode] || 'https://www.nestspace.com';
            const targetHost = new URL(targetUrl).hostname;
            if (window.location.hostname !== targetHost) {
              window.location.href = targetUrl;
            }
          }
        }
      ).catch(error => {
        console.log('error:' + error);
      })
    },
    handleRightMenuMouseEnter(){
      this.isShowRightMenu = true;
    },
    handleRightMenuMouseLeave(){
      this.isShowRightMenu = false;
    },
    btn_language: function (type) {
      switch (type) {
        case 'en':
          localStorage.setItem("locale", "en");
          this.$i18n.locale = localStorage.getItem("locale");
          localStorage.setItem("lang", "en");
          // alert('切换到英文');
          break;
        case 'zh':
          localStorage.setItem("locale", "zh");
          this.$i18n.locale = localStorage.getItem("locale");
          localStorage.setItem("lang", "zh");
          // alert('切换到中文');
          break;
        default:
          break;
      }
      location.reload();
    },
    handleMouseEnter(index) {
      this.listShow.splice(index, 1, true);
    },
    handleMouseLeave(index) {
      this.listShow = [false, false, false, false, false];
    },
    btnYouTobe(){
      window.open('https://www.youtube.com/watch?v=YQcWsQYJlRU&list=PLFDxZAZnncJJwndl0C3C97oVe8LA_fBF1&index=2', '_blank');
    }
  }
}
</script>
